import { render, staticRenderFns } from "./Ticksvg.vue?vue&type=template&id=09f57cd3&"
import script from "./Ticksvg.vue?vue&type=script&lang=js&"
export * from "./Ticksvg.vue?vue&type=script&lang=js&"
import style0 from "./Ticksvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports